// used as word-join indicator in edit ops
export const ZERO_WIDTH_WS = String.fromCodePoint(8203)

// u'\u00AD'
export const SOFT_HYPHEN = String.fromCodePoint(173)

export const HYPHEN = '¬'
